import "./Header.css"

const Header = () => {
    return (
        <div className="seven">
            <h1 className="seven-h1">FilterPaper</h1>
        </div>
    )
}

export default Header